import { Member } from 'common/api/models/Member';

export function toPhoneE164(phone: string | undefined): string | undefined {
  if (!phone) {
    return undefined;
  }
  phone = phone.replace(/[^0-9]/g, '');
  if (phone.length === 10) {
    phone = '1' + phone;
  }
  return '+' + phone;
}

export function fromPhoneE164(phone: string | undefined): string | undefined {
  if (!phone) {
    return undefined;
  }
  if (phone.length === 12) {
    return phone.substring(2, 5) + '-' + phone.substring(5, 8) + '-' + phone.substring(8, 12);
  } else {
    return phone;
  }
}

export const REVENUE_RANGES = [
  0,
  100,
  500,
  1000,
  1500,
  2000,
  3000,
  4000,
  5000,
  7000,
  10000,
  15000,
  20000,
  40000,
  100000,
  200000,
  500000,
  750000,
  1000000,
  10000000,
];
export function formatRevenueNumber(revenue: number) {
  if (revenue < 1000) {
    return '$' + revenue + 'k';
  } else if (revenue < 1000000) {
    return '$' + revenue / 1000 + 'm';
  } else {
    return '$' + revenue / 1000000 + 'b';
  }
}
export function formatRevenueRange(revenue: number | undefined) {
  if (!revenue) {
    return 'None';
  }
  let i = REVENUE_RANGES.indexOf(revenue);
  if (i === -1) {
    return 'Invalid revenue (' + revenue + ')';
  }
  if (i === 1) {
    return 'Up to ' + formatRevenueNumber(revenue);
  }
  if (i === REVENUE_RANGES.length - 1) {
    return formatRevenueNumber(REVENUE_RANGES[i - 1]) + '+';
  }
  return formatRevenueNumber(REVENUE_RANGES[i - 1]) + ' - ' + formatRevenueNumber(revenue);
}
export function getCurrencySymbol(currencyCode: string) {
  const num = 0;
  const formatted = num.toLocaleString(undefined, { style: 'currency', currency: currencyCode });
  let i = formatted.indexOf('0');
  return formatted.substring(0, i).trim();
}
export function formatMoneyValue(amount?: number) {
  if (!amount) {
    return '';
  }
  let formatted = amount
    .toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
    })
    .substring(1);
  return formatted;
}
export function formatDecimal(value: any, places?: number) {
  places = places !== undefined ? places : 2;
  value = String(value)
    .trim()
    .replace(/[^0-9-\.]/g, '');

  // prevent entering multiple decimal points
  let i = value.indexOf('.');
  if (i > -1) {
    let nextDot = value.substring(i + 1).indexOf('.');
    if (nextDot > -1) {
      value = value.substring(0, i + nextDot + 1);
    }

    // prevent entering too many decimal places
    if (value.length > i + places) {
      value = value.substring(0, i + places + 1);
    }
  }
  return value;
}
export function formatFullname(user?: Member) {
  if (!user) {
    return '';
  }
  return user.firstName + ' ' + user.lastName;
}



// WEBPACK FOOTER //
// ./src/common/utils/format.ts